<template>
  <div>
    <div class="page-loader" v-if="loading">
      <p class="text-center">Bezig met laden...</p>
    </div>
    <div v-else>
      <div v-if="found">
        <div v-if="$store.state.favoriteLimitReached" class="favorite-limit-popup">
          <div class="favorite-limit-container">
            <p>Je kunt niet meer dan <strong>{{ $store.state.favorites.length }}</strong> favorieten selecteren. Verwijder er eerst een voordat je een nieuwe toevoegd.</p>
            <button @click.prevent="$store.commit('favoriteLimitReached', false)" class="btn btn-primary">Sluiten</button>
          </div>
        </div>
        <main-header/>
        <router-view :key="$route.fullPath"/>
      </div>
      <div v-else>
        <p class="text-center text-danger mt-5">Er staat geen woningselector geregistreerd op dit domein!</p>
      </div>
    </div>
  </div>
</template>

<script>
  import MainHeader from '../components/Header'
  export default {
    components: {
      MainHeader
    },
    data () {
      return {
        found: null,
        loading: true
      }
    },
    mounted () {
      let slug = this.$route.params.selector_id;

      let timestamp = Math.floor(Date.now() / 1000);
      let expires = this.$store.state.expires

      if(expires && expires < timestamp){
        this.$store.commit('expired')
      }
      this.$getUser()
      this.axios.get(slug + '?t=' + timestamp).then((result) => {
        this.$store.commit('setApiData', result.data)
        this.found = true
        this.checkFavorites()
      }).catch((e) => {
        console.error(e)
        this.found = false
      }).finally(() => {
        this.loading = false

      })
    },
    methods: {
      // Remove favorites from other selectors
      checkFavorites () {
        let favorites = this.$favorites
        favorites = favorites.map((favorite) => {
          return favorite.id
        })
        this.$store.commit('setFavorites', favorites)
      }
    }

  }
</script>

<style lang="scss">
  .page-loader {
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }
  .favorite-limit-popup {
    position: fixed;
    text-align: center;
    z-index: 99999999;
    background-color: rgba(0,0,0,.3);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .favorite-limit-container {
    background-color: #fff;
    padding: 25px;
    border-radius: 5px;
    max-width: 500px;
  }
</style>
